namespace RedBullMOBILE360.Sms {

    @Serenity.Decorators.registerClass('RedBullMOBILE360.Sms.WhitelistMemberDialog')
    export class WhitelistMemberDialog extends Serenity.EntityDialog<WhitelistMemberRow, any> {
        protected getFormKey() { return WhitelistMemberForm.formKey; }
        protected getIdProperty() { return WhitelistMemberRow.idProperty; }
        protected getLocalTextPrefix() { return WhitelistMemberRow.localTextPrefix; }
        protected getNameProperty() { return WhitelistMemberRow.nameProperty; }
        protected getService() { return WhitelistMemberService.baseUrl; }
        protected getDeletePermission() { return WhitelistMemberRow.deletePermission; }
        protected getInsertPermission() { return WhitelistMemberRow.insertPermission; }
        protected getUpdatePermission() { return WhitelistMemberRow.updatePermission; }

        protected form = new WhitelistMemberForm(this.idPrefix);
    }
}